import React from 'react';
import { PrimaryButton } from 'src/shared/components/button/Button';
import CMSArticle from 'src/shared/components/cms-article/CMSArticle';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/shared/components/ui/dialog';

type WelcomeDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onGetStarted: () => void;
};

const WelcomeDialog = ({ open, onOpenChange, onGetStarted }: WelcomeDialogProps) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className='w-[596px] max-w-[calc(100vw-2rem)] rounded-lg'>
                <DialogHeader>
                    <DialogTitle className='text-3xl text-primary font-normal'>Welcome to the home of Nature Intelligence</DialogTitle>
                </DialogHeader>
                <CMSArticle slug='site-summary-welcome-modal' />
                <div className='flex justify-start'>
                    <PrimaryButton onClick={onGetStarted}>Get started</PrimaryButton>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default WelcomeDialog;
